import { render, staticRenderFns } from "./after-sales-status.vue?vue&type=template&id=63e26424&scoped=true"
import script from "./after-sales-status.vue?vue&type=script&lang=js"
export * from "./after-sales-status.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e26424",
  null
  
)

export default component.exports